module.exports = __webpack_public_path__ + "static/media/hero-works-two.931962e1.png";